// extracted by mini-css-extract-plugin
export default {"documentScreenWrapper":"SingleScreen_documentScreenWrapper__ZJd4p","fullHeight":"SingleScreen_fullHeight__Nl-yS"};